import { SectionHeader } from '../../components';

export const TagSectionHeader = () => {
  return <SectionHeader>Tags</SectionHeader>;
};
